var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60651 6.70711C9.99703 6.31658 9.99703 5.68342 9.6065 5.29289C9.21598 4.90237 8.58281 4.90237 8.19229 5.29289L2.19231 11.2929C2.08726 11.3979 2.01048 11.5205 1.96194 11.6512C1.93011 11.7368 1.90965 11.8278 1.9024 11.9226C1.89842 11.9741 1.89842 12.0259 1.9024 12.0774C1.90965 12.1722 1.93011 12.2632 1.96194 12.3488C2.01048 12.4795 2.08726 12.6021 2.19231 12.7071L8.19229 18.7071C8.58281 19.0976 9.21598 19.0976 9.6065 18.7071C9.99703 18.3166 9.99703 17.6834 9.60651 17.2929L5.31362 13H20.8995C21.4517 13 21.8995 12.5523 21.8995 12C21.8995 11.4477 21.4517 11 20.8995 11H5.31362L9.60651 6.70711Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.e7a3a4a5ebd235cdd09e477932ba8e91.svg";
export { ForwardRef as ReactComponent };